import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { FilterProvider } from './contexts/FilterContext';
import { NotificationProvider, useNotifications } from './contexts/NotificationContext';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Sidebar from './components/Sidebar/Sidebar';
import ProductsSection from './components/ProductsSection/ProductsSection';
import TopRated from './components/TopRated/TopRated';
import Footer from './components/Footer/Footer';
import Bannieres from './components/Bannieres/Bannieres';
import ProduitEnPromotion from './components/ProduitEnPromotion/ProduitEnPromotion';
// import Testimonials from './components/Testimonials/Testimonials';
// import DiscountForm from './components/DiscountForm/DiscountForm';
import ProductDetail from './components/ProductDetail/ProductDetail';
import Login from './pages/Auth/Login/Login';
import Register from './pages/Auth/Register/Register';
import ForgotPassword from './pages/Auth/ForgotPassword/ForgotPassword';
import ResetPassword from './pages/Auth/ResetPassword/ResetPassword';
import Cart from './components/Cart/Cart';
import Checkout from './components/Checkout/Checkout';
import Profile from './components/Profile/Profile';
import MyOrders from './pages/Orders/MyOrders';
import Wishlist from './pages/Wishlist/Wishlist';
import SearchResults from './pages/Search/SearchResults';
import { AdminRouter, ModernAdminLayout } from './components/Admin';
import NotificationContainer from './components/Notification/NotificationContainer';
import './assets/css/admin-modern.css';
import styles from './App.module.css';

// Créer le client React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function AppContent() {
  const { notifications, removeNotification } = useNotifications();

  return (
    <>
      <Router>
        <FilterProvider>
          <Routes>
            {/* Routes Admin - Layout séparé */}
            <Route path="/admin/*" element={
              <ModernAdminLayout>
                <AdminRouter />
              </ModernAdminLayout>
            } />

            {/* Routes Client - Layout normal */}
            <Route
              path="/*"
              element={
                <div className={styles.app}>
                  <Header />
                  <Routes>
                    <Route
                      path="/"
                      element={
                        <>
                          <Hero />
                          <div className={styles.container}>
                            <div className={styles.mainContent}>
                              <Sidebar />
                              <div id="products-section">
                                <ProductsSection />
                              </div>
                            </div>
                            <Bannieres />
                            <ProduitEnPromotion />
                            <TopRated />
                            {/* <Testimonials /> */}
                            {/* <DiscountForm /> */}
                          </div>
                        </>
                      }
                    />
                    <Route path="/product/:id" element={<ProductDetail />} />
                    <Route path="/search" element={<SearchResults />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/cart" element={<Cart />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/orders" element={<MyOrders />} />
                    <Route path="/wishlist" element={<Wishlist />} />
                  </Routes>
                  <Footer />
                </div>
              }
            />
          </Routes>
        </FilterProvider>
      </Router>
      <NotificationContainer
        notifications={notifications}
        onRemove={removeNotification}
      />
    </>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <NotificationProvider>
        <AuthProvider>
          <CartProvider>
            <AppContent />
          </CartProvider>
        </AuthProvider>
      </NotificationProvider>
    </QueryClientProvider>
  );
}

export default App;